import { Col, Form, Row } from "antd"
import type { BaseOptionType } from "antd/lib/select"
import React from "react"

import { LockedLabel } from "../../../../../../components/LockedLabel.tsx"
import { buildEntityLabelMap } from "../../../../../../utils/select/entity-labels.ts"
import { type ProjectFormData } from "../../project-form-data.ts"
import { ManagersSelector } from "./ManagersSelector.tsx"

interface StakeholdersAndRolesSectionProps {
  options: Record<string, BaseOptionType[]>
  assignedSalesAllowed?: boolean
  assignedPMAllowed?: boolean
  assignedProjectManagers?: Record<string, any>[] | null
  assignedSalesManagers?: Record<string, any>[] | null
}

function resolveLabel(text: string, locked: boolean): React.ReactNode {
  return locked ? <LockedLabel text={text} /> : text
}

export function StakeholdersAndRolesSection({
  options,
  assignedPMAllowed,
  assignedSalesAllowed,
  assignedProjectManagers,
  assignedSalesManagers
}: StakeholdersAndRolesSectionProps) {
  const isPMLocked = !assignedPMAllowed
  const isSalesLocked = !assignedSalesAllowed
  const pmLabels = buildEntityLabelMap(assignedProjectManagers)
  const salesLabels = buildEntityLabelMap(assignedSalesManagers)

  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item<ProjectFormData>
            name="project_managers"
            label={resolveLabel("Project Manager", isPMLocked)}
          >
            <ManagersSelector
              placeholder="Enter project manager"
              options={options?.project_manager}
              fallbackLabels={pmLabels}
              disabled={isPMLocked}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item<ProjectFormData>
            name="sales_manager"
            label={resolveLabel("Sales Manager", isSalesLocked)}
          >
            <ManagersSelector
              placeholder="Enter sales manager"
              options={options?.sales_manager}
              fallbackLabels={salesLabels}
              disabled={isSalesLocked}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
